var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Icon, Row, Typography } from "antd";
import React from "react";
var ErrorBoundaryView = /** @class */ (function (_super) {
    __extends(ErrorBoundaryView, _super);
    function ErrorBoundaryView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: _this.props.forceError || false
        };
        return _this;
    }
    ErrorBoundaryView.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    };
    ErrorBoundaryView.prototype.componentDidCatch = function (error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error(error, errorInfo);
    };
    ErrorBoundaryView.prototype.render = function () {
        var hasError = this.state.hasError;
        var _a = this.props, children = _a.children, title = _a.title, subTitle = _a.subTitle, alignTop = _a.alignTop;
        if (hasError) {
            // You can render any custom fallback UI
            return (React.createElement(Row, { type: "flex", justify: "center", align: "middle", className: alignTop ? "" : "align-center-align-middle" },
                React.createElement(Col, { className: "padding-md background-gray-2", style: { borderRadius: "6px" } },
                    React.createElement(Row, { type: "flex", gutter: 16 },
                        React.createElement(Col, null,
                            React.createElement(Icon, { className: "color-pink", component: function () { return React.createElement(FontAwesomeIcon, { size: "3x", icon: faExclamationTriangle }); } })),
                        React.createElement(Col, null,
                            React.createElement(Typography.Text, { strong: true }, title || "Something went wrong"),
                            React.createElement("br", null),
                            React.createElement(Typography.Text, null, subTitle || "Contact Yodlee for more help"))))));
        }
        return children;
    };
    return ErrorBoundaryView;
}(React.Component));
export default ErrorBoundaryView;
//# sourceMappingURL=index.js.map